import styled from "styled-components";

export const Spacer = styled.div`
  height: 50px;
  width: 100%;
  display: block;
`;
